<div class="row">
	<div class="col-lg-6">
		<div class="mb-3">
			<label>Modify template:</label>
			<select [(ngModel)]="selectedTemplate" (ngModelChange)="templateChange($event)" class="form-control">
				@for (template of templates; track template) {
					<option [ngValue]="template">{{template.description}}</option>
				}
			</select>
		</div>
	</div>
</div>
@if (selectedTemplate) {
	<div class="row">
		@if (selectedTemplate.template_id !== null) {
			<div class="col-lg-6">
				<div class="panel constrain">
					<div class="heading">Current template</div>
					<div class="content nopad">
						<div>
							<textarea [(ngModel)]="rawTemplate" class="form-control flush" style="min-height: 400px;" readonly></textarea>
						</div>
					</div>
				</div>
				<app-action-button [action]="DeleteTemplate" [context]="this" processing="Deleting..." complete="Template deleted" confirm="Are you sure?" btnClass="red">Delete
					Template</app-action-button>
			</div>
		}
		@if (selectedTemplate.template_id === null) {
			<div class="col-lg-6">
				<div class="panel">
					<div class="heading">New template name</div>
					<div class="content">
						<div>
							<input [(ngModel)]="newTemplateDescription" type="text" class="form-control">
						</div>
					</div>
				</div>
			</div>
		}
		<div class="col-lg-6">
			<div class="panel constrain">
				<div class="heading">New template</div>
				<div class="content nopad">
					<div>
						<textarea [(ngModel)]="newTemplate" class="form-control flush" style="min-height: 400px;"></textarea>
					</div>
				</div>
			</div>
			@if (selectedTemplate.template_id !== null) {
				<app-action-button [action]="UploadTemplate" [context]="this" processing="Updating..." complete="Template updated" btnClass="green">Update Template</app-action-button>
			}
			@if (selectedTemplate.template_id === null) {
				<app-action-button [action]="CreateTemplate" [context]="this" processing="Creating..." complete="Template created" btnClass="green">Create Template</app-action-button>
			}
		</div>
	</div>
}